import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaBriefcase, FaProjectDiagram, FaEnvelope, FaInfoCircle } from 'react-icons/fa';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const current = location.pathname;

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="nav-container">
        <div className="logo-container" onClick={() => go('/')}>
          <img src="/logo.png" alt="Syntax2Scale Logo" className="logo-image" />
        </div>

        <button className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(s => !s)} aria-label="Toggle menu">
          <span/><span/><span/>
        </button>

        <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <li><a className={`nav-link ${current === '/' ? 'active' : ''}`} onClick={() => go('/')}> <FaHome/> Home</a></li>
          <li><a className={`nav-link ${current === '/about' ? 'active' : ''}`} onClick={() => go('/about')}><FaInfoCircle/> About</a></li>
          <li><a className={`nav-link ${current === '/services' ? 'active' : ''}`} onClick={() => go('/services')}> <FaBriefcase/> Services</a></li>
          <li><a className={`nav-link ${current === '/projects' ? 'active' : ''}`} onClick={() => go('/projects')}> <FaProjectDiagram/> Projects</a></li>
          <li><a className={`nav-link ${current === '/contact' ? 'active' : ''}`} onClick={() => go('/contact')}> <FaEnvelope/> Contact</a></li>
        </ul>
      </nav>
    </header>
  );
}
